import {get, map, mapValues, isString, startCase} from 'lodash'

import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'

class SelectRadio extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id      : this.props.id,
      schema  : this.props.schema,
      classes : get(this, 'props.AXGClasses.select', 'form-group'),
      // value   : '',
      value   : get(this.props, 'schema.data.default') || '',
      data    : get(this, 'props.schema.data.fallback',
                    [ {value: 'loading', text: 'Loading ...'}] ),
      updates: get(this.props.schema, 'updates', ''),
    }
  }

  handleRadioClick(e) {
    var component = this
    var value = e.target.value
    // var index = e.nativeEvent.target.selectedIndex
    // var text = e.nativeEvent.target[index].text
    var text = e.nativeEvent.target.text
    // var text = e.target.text
    console.log(`handleRadioClick value / text: ${value} / ${text}`)
    this.setState({
      value: value
    })
    console.info(`Redux Update: ${this.props.AXGKey}`);
    this.props.actions.setAppxigonState({
      key   : [this.props.AXGKey],
      value : value,
    })
    // REVIEW: how to get text ?
    // get from transformed data obj?
    // this.props.actions.setAppxigonState({
    //   key   : `${this.props.AXGKey}.text`,
    //   value : text,
    // })

    let updates = component.state.updates
    if (updates) {
      if (isString(updates)) {
        updates = [updates]
      }
      console.log(`Update dependency for: ${JSON.stringify(updates)}`)
      updates.forEach((u)=> {
        component.props.actions.setAppxigonState({
          key : `dependency.${u}`,
          // make it a string. value not important, just for redux value change detection
          value: JSON.stringify(value),
        })
      })
    }
  }

  componentWillMount() {
    var component = this
    var schema = this.state.schema
    var dataSourceDef = get(schema, 'data.source') // e.g. 'ref.users' => 'data.ref.users'
    // console.log(dataSourceDef);
    var refDataSource = get(this.props.AXGDataSource, `${dataSourceDef}.source`, null)
    var refDataTransform = get(this.props.AXGDataSource, `${dataSourceDef}.transform`, null)
    var refDataFallback = get(this.props.AXGDataSource, `${dataSourceDef}.fallback`, null)
    // console.log(refDataSource);
    // console.log(refDataTransform);
    if (refDataSource) {
      var data = []
      // var dataTransform = refDataDef.transform
      $.ajax({
        url: refDataSource,
        method: 'GET'
      }).then(function(rawData) {
        // console.log(rawData)
        if (refDataTransform) {
          var keyMap = refDataTransform
          data = map(rawData, (item, key)=> {
            return mapValues(keyMap, (val)=> {
              return item[val]
            })
          })
        } else {
          data = rawData
        }
        component.setState({
          data  : data
        })
      })
      // TODO: handle ajax call failure
      // this.setState({
      //   data  : [ { value: 'error', text: 'Unable to load data ...' } ],
      // })
    } else {
      if (refDataFallback) {
        component.setState({
          data  : refDataFallback,
        })
      }
    }
    let storeKey = this.props.AXGKey // Default storeKey
    // Set current or default value
    var currentValue = get(component.props.appxigonState, component.props.AXGKey, '') || component.state.value
    console.log(`AXGKey / currentValue: ${component.props.AXGKey} / ${currentValue}`)
    component.setState({
      value: currentValue,
    })
    component.props.actions.setAppxigonState({
      key : storeKey,
      value: currentValue,
    })
  }

  refreshData() {
    // TODO ...
  }

  componentWillReceiveProps(nextProps) {
    var component = this
    // REVIEW: is this a proper way ? Will this trigger unnecessary update?
    var dependencyKey = `dependency.${this.props.AXGKey}`
    var nextDepencyValue = get(nextProps.appxigonState, dependencyKey, '')
    if (this.state.dependency != nextDepencyValue) {
      console.info(`select: (${component.state.id}) dependency changed: refreshData`)
      this.refreshData()
    }
    this.setState({
      dependency: nextDepencyValue,
    })
  }

  render() {
    var schema = this.state.schema
    var id = `select-${this.state.id}`
    var title = get(schema, 'title', startCase(this.state.id))
    var icon = get(schema, 'icon', null)

    return (
      <div className={`${this.state.classes}${this.props.show ? '' : ' hidden'}`}>
        <div className='input-group'>
          <span class="input-group-addon">
            <i className="material-icons">{ icon }</i>
          </span>
          <label htmlFor={id}>{title}</label>
          {
            this.state.data.map(
              (i) =>
                <label key={i.value} className='radio-inline'>
                  <input
                    type='radio'
                    name={`${this.props.AXGKey}-${id}`}
                    value={i.value}
                    checked={
                      // Non-strict comparison here
                      // for value could be number or text
                      this.state.value == i.value
                    }
                    onClick={this.handleRadioClick.bind(this)}/>
                    {i.text}
                </label>
            )
          }
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SelectRadio)



// WEBPACK FOOTER //
// ./item-types/select-radio.js